﻿/**
 * @description login登录配置
 * @description saas登录需要设置项:
 * @description private私有化登录设置:
 * @description 无登录无限制设置:
 */
export const login = {
    // 开启帮助弹窗 现有登录dns设置帮助弹窗，登录辅助弹窗
    isHelp: true,
    // isHelp: false,

    // login拦截登录的配置
    // private私有化登陆页面路径
    loginPrivatePath: '/login',
    // saas化登录页面
    // loginSaasPath: '//byj_20210610.p.make.test-dcloud.portal1.portal.yun300.cn/admin/',
    // loginSaasPath: '//demo_52aa3741d4c0440087f6f57c05be7db0.p.make.test-dcloud.portal1.portal.yun300.cn/admin/',
    //loginSaasPath: '//qinhui20210610.p.make.test-dcloud.portal1.portal.yun300.cn/admin/',
    // loginSaasPath: '//gongchengshi.p.make.test-dcloud.portal1.portal.yun300.cn/admin/',

    // token失效回退到登录页时是否记录本次的路由
    isRecordRoute: true,
    // token名称
    tokenType: 'instance', // accessToken or instance 云服务模式saas
    // tokenType: 'accessToken', // accessToken or instance 私有化模式private

    // instance白名单id，需要向dns登录拦截方提供 2021年5月18日晚上通知我此属性为动态的 ,改为测试使用的值
    //accessTestInstance: 'dev_product_group',
    // accessTestInstance: 'tinhangyu_20210610',
    // accessTestInstance: 'byj_20210610',
    //accessTestInstance: 'demo_72a7077395944a7dbf3c8c8b11d2292c',
    //accessTestInstance: 'demo_5892dcbdd16446f3884a35e97686ca9d',
    //accessTestInstance: 'hackmock',
    //accessTestInstance: 'DEMO_19e27fc782ca4eaf8259251a620fbd33',
    // accessTestInstance: 'demo_6bbcea4745624c51921bed024c3a4700',
    // accessTestInstance: 'demo_52aa3741d4c0440087f6f57c05be7db0',
    //accessTestInstance: 'lxnwzcdtest0830',

    // 在跟目录中创建 .env.development.local 文件并配置环境变量 VITE_ACCESS_TEST_INSTANCE
    // 参考 .env.development 文件配置，不要直接修改这里的内容
    accessTestInstance: import.meta.env.VITE_ACCESS_TEST_INSTANCE ?? 'shen1029_098a34cf6d8140c39ef0111b372be6b5', //'new2022011815412849819',
    //accessTestInstance: 'qinhui20210610',
    // accessTestInstance: 'DEMO_75ee8a47b02a4ae185afee6bd4f4f73b',

    // accessInstance登录的instance记录别名
    saasTokenKey: 'ce-token-saas',
    //token在localStorage、sessionStorage存储的key的名称
    privateTokenKey: 'ce-token-private',

    // 登录用户信息
    userDataKey: 'ce-user-info',
    // 登录类型，｜ vistor ｜ saas | private ｜
    loginInterceptionType: 'saas', // 云服务模式
    // loginInterceptionType: 'private', // 私有化模式
    // loginInterceptionType: 'vistor', // 访客模式无需登录

    // 访客数据:
    visitorUser: { username: 'visitor', avatar: 'el-icon-user' },
    // 访客登录目录权限: all:全部访问，[]:部分访问
    visitorAuths: 'all',
    // visitorAuths: ['center', 'home', 'docs', 'profile', 'user'],

    // 是否显示顶部进度条
    isProgressBar: true,
};
